import React, { useEffect, useMemo, useState, useCallback, useRef } from "react";
import AppBar from "@mui/material/AppBar";
import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  Modal,
  Paper,
  Typography,
  useTheme,
  useMediaQuery,
  Popper,
  List,
  ListItemButton,
  ListItemText,
  CircularProgress,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { GetAllProduct } from "../../redux/action/MarketPlace/Product-Filter";
import { AllCompanysDetails } from "../../redux/action/Company&User/AllCompanys";
import { AllapprovalCompanysDetails } from "../../redux/action/Company&User/ApprovalCompanys.js";
import { useDispatch, useSelector } from "react-redux";
import Toolbar from "@mui/material/Toolbar";
import Container from "@mui/material/Container";
import SearchIcon from "@mui/icons-material/Search";
import { styled } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import bxiLogo from "../../assets/BXI_LOGO.png";
import brandWorldLogo from "../../assets/BrandWorldLogo.svg";
import { useNavigate } from "react-router-dom";
import OpenInFullRoundedIcon from "@mui/icons-material/OpenInFullRounded";
import { useGetLoggedInUser } from "./Hooks";
import { resolveAdminPortalType } from "../../utils/adminPortal";
import axios from "axios";
import { getToken } from "../../common/ApiUtility";
import { getAdminMarketplacePreviewPath } from "../../utils/adminMediaBuyingPath";
import { allNotification } from "../../redux/action/Notification/getNotifications";
import AvatarGenerator from "../Layouts/AvatarGenerator.jsx";
import { format } from "timeago.js";
import { useContext } from "react";
import { ThemeContext } from "../../ThemeContext"; // Adjust path as needed
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';

const CloseIconForNotification = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets1/HeaderIcon/CloseIconForNotification.svg';
const barterLogo = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/BXI_LOGO.png';
const NotifyIcon = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/Notification.png';
const ProfileVector = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/ProfileImage/ProfileVector.svg';
const Username = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/ProfileImage/username.svg';
const Gmail = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/ProfileImage/gmail.svg';
const Lastlogin = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/ProfileImage/lastlogin.svg';
const Role = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/ProfileImage/role.svg';
const Access = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/ProfileImage/access.svg';
const CloseIcon = 'https://bxidevelopment1.s3.ap-south-1.amazonaws.com/assets/CloseIcon.svg';


export let search = "";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "24px",
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
  backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.08)" : "#f1f3f4",
  border: `1px solid transparent`,
  transition: "all 0.2s ease",
  "&:hover": {
    backgroundColor: theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.12)" : "#e8eaed",
  },
  "&:focus-within": {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.primary.main}`,
    boxShadow: `0 0 0 4px ${theme.palette.primary.light}40`,
  }
}));
const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "20ch",
    },
    [theme.breakpoints.up("md")]: {
      width: "40ch",
    },
    [theme.breakpoints.up("lg")]: {
      width: "70ch",
    },
  },
}));

const style = {
  position: "absolute",
  top: { xs: "50%", sm: "37%" },
  left: { xs: "50%", sm: "80%" },
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "32%" },
  maxHeight: { xs: "80vh", sm: "400px" },
  overflow: "auto",
  bgcolor: "#ffffff",
  boxShadow: "0 24px 48px rgba(0,0,0,0.12)",
  p: { xs: "20px", sm: "32px" },
  border: "1px solid #e8eaed",
  borderRadius: "20px",
  maxWidth: "500px",
  minWidth: "250px",
};

const notificationModalStyle = {
  position: "absolute",
  top: { xs: "50%", sm: "38%" },
  left: { xs: "50%", sm: "79%" },
  transform: "translate(-50%, -50%)",
  width: { xs: "90%", sm: "32%" },
  maxHeight: { xs: "85vh", sm: "340px" },
  overflow: "hidden",
  bgcolor: "#ffffff",
  boxShadow: "0px 20px 44px rgba(18, 19, 23, 0.12)",
  p: { xs: "16px", sm: "20px" },
  border: "1px solid rgba(33, 34, 38, 0.06)",
  borderRadius: "22px",
  maxWidth: "500px",
  minWidth: "250px",
};

const AdminHeader = ({ onMenuClick }) => {
  const { darkMode, setDarkMode } = useContext(ThemeContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [ProfileModal, setProfileModal] = useState(false);
  const [marketplacesearch, setMarketplaceSearch] = useState("");
  const [globalSearchQuery, setGlobalSearchQuery] = useState("");
  const [globalSearchResults, setGlobalSearchResults] = useState({ companies: [], orderRequests: [], products: [] });
  const [globalSearchLoading, setGlobalSearchLoading] = useState(false);
  const [globalSearchOpen, setGlobalSearchOpen] = useState(false);
  const searchAnchorRef = useRef(null);
  const globalSearchDebounceRef = useRef(null);
  const [notificationDot, setNotificationDot] = useState(true);
  const [totalCountBXIArray, SetTotalCountBXIArray] = useState([]);
  const [totalCountBuyerArray, setTotalCountBuyerArray] = useState([]);
  const [totalCountSellerArray, setTotalCountSellerArray] = useState([]);
  const [incrementAll, setIncrementAll] = useState(false);
  const [UpdateNotiticationStatus, setUpdateNotiticationStatus] =
    useState(false);
  const [unReadCountOfAll, setUnReadCountOfAll] = useState(null);
  const { getNotification } = useSelector((state) => state.allNotifiactions);
  const MAX_MODAL_NOTIFICATIONS = 80;
  const getSafeMessage = (item) =>
    String(item?.message || item?.body || item?.title || "");
  // A v2 notification carries an authored `title` (the headline the copy was
  // written as) and a `body` (the supporting line). Every surface rendered only
  // `message` — which the fetch layer collapses to body||title — so the headline
  // was dropped and the bell showed the terser body instead of the notification
  // as authored. The legacy `type` field, used as the heading, does not exist on
  // v2 rows at all, so that heading rendered blank.
  const getSafeTitle = (item) =>
    String(item?.title || item?.type || "");
  const getSafeBody = (item) => {
    const body = String(item?.body || item?.message || "");
    return body === getSafeTitle(item) ? "" : body;
  };
  const notificationList = useMemo(
    () => (Array.isArray(getNotification) ? getNotification : []),
    [getNotification]
  );
  const modalNotificationList = notificationList.slice(0, MAX_MODAL_NOTIFICATIONS);

  search = marketplacesearch;
  useEffect(() => {
    if (window.location.pathname.includes("marketplace")) {
      dispatch(GetAllProduct());
    } else if (window.location.pathname.includes("companies")) {
      dispatch(AllCompanysDetails());
    } else if (window.location.pathname.includes("approvallisting")) {
      dispatch(AllapprovalCompanysDetails());
    }
  }, [dispatch, search]);

  const fetchGlobalSearch = useCallback(async (q) => {
    if (!q || q.length < 2) {
      setGlobalSearchResults({ companies: [], orderRequests: [], products: [] });
      setGlobalSearchOpen(false);
      return;
    }
    setGlobalSearchLoading(true);
    setGlobalSearchOpen(true);
    try {
      const token = getToken();
      const res = await axios.get("aggregator/admin/search", {
        params: { q },
        withCredentials: true,
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      setGlobalSearchResults({
        companies: res?.data?.companies ?? [],
        orderRequests: res?.data?.orderRequests ?? [],
        products: res?.data?.products ?? [],
      });
    } catch {
      setGlobalSearchResults({ companies: [], orderRequests: [], products: [] });
    } finally {
      setGlobalSearchLoading(false);
    }
  }, []);

  useEffect(() => {
    if (globalSearchDebounceRef.current) clearTimeout(globalSearchDebounceRef.current);
    const q = (typeof marketplacesearch === "string" ? marketplacesearch : "").trim();
    if (q.length < 2) {
      setGlobalSearchOpen(false);
      setGlobalSearchResults({ companies: [], orderRequests: [], products: [] });
      return;
    }
    globalSearchDebounceRef.current = setTimeout(() => fetchGlobalSearch(q), 300);
    return () => {
      if (globalSearchDebounceRef.current) clearTimeout(globalSearchDebounceRef.current);
    };
  }, [marketplacesearch, fetchGlobalSearch]);

  const getProductSearchImage = (product) => {
    return (
      product?.ProductImages?.[0]?.url ||
      product?.VoucherImages?.[0]?.url ||
      product?.ProductImage?.[0]?.url ||
      product?.productImage?.[0]?.url ||
      "https://antigravity.google/placeholder.png"
    );
  };

  const handleGlobalSearchSelect = (type, id, item) => {
    setGlobalSearchOpen(false);
    setMarketplaceSearch("");
    if (type === "company") navigate(`/admindashboard/companylanding/${id}`);
    else if (type === "orderRequest") navigate(`/admindashboard/orderrequest/${id}`);
    else if (type === "product") {
      const route = getAdminMarketplacePreviewPath(item);
      if (route) {
        if (item?.ListingType === "Media") {
          navigate(route, { state: { type: "Media" } });
        } else {
          navigate(route);
        }
      }
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleProfileModalopen = () => {
    setProfileModal(true);
  };
  const handleProfileModalclose = () => {
    setProfileModal(false);
  };
  const {
    data: loggedInUser,
    isLoading,
    isError,
    isSuccess,
  } = useGetLoggedInUser();
  const resolvedAdminType = resolveAdminPortalType(loggedInUser?.adminType);
  const normalizedAccess = React.useMemo(
    () =>
      Array.isArray(loggedInUser?.acess)
        ? loggedInUser.acess.map((item) => String(item || "").trim())
        : [],
    [loggedInUser?.acess]
  );
  const canAccessSellerhub =
    resolvedAdminType === "brand_world" &&
    (normalizedAccess.includes("All") || normalizedAccess.includes("SELLERHUB"));
  const canAccessNotifications =
    normalizedAccess.includes("All") || normalizedAccess.includes("NOTIFICATIONS");

  const companyName = "BXI Pvt Ltd";

  // No receiverId is sent on purpose. /api/v1/admin/getloggedinnuser returns the
  // admin_user document, which has no companyId field at all, so the id this
  // used to derive was always "" — and the fetch was guarded on it, so the bell
  // never made a request and was permanently empty. The backend resolves the
  // right scope for an admin session on its own (its own id plus the ADMIN and
  // BRANDWORLD receiver types), which is the only way Brand World notifications
  // can be reached.
  useEffect(() => {
    dispatch(allNotification({ page: 1, limit: 80 }));
  }, [dispatch]);

  const UpdateNotifications = async (data) => {
    let status = null;

    status = !Boolean(data?.read);

    await axios
      .patch(
        `v2/notifications/${data._id}/read`,
        { read: status },
        { withCredentials: true }
      )
      .then(() => {
        dispatch(allNotification({ page: 1, limit: 80 }));
      })
      .catch((err) => { });
  };

  // useEffect(() => {
  //   socket.on("notificationS", (data) => {
  //     if (data !== null) {
  //       // dispatch(
  //       //   notifications(data.sellerId, data.buyerId, data.message, data.type)
  //       // );
  //       setNotification((prevNotification) => [data, ...prevNotification]);
  //       setNotificationDot(true);
  //       setIncrementAll(true);
  //       // const audio = new Audio(notificationbell);
  //       // audio.play();
  //     }
  //   });

  //   socket.on("MessagesNotification", (data) => {
  //     if (data !== null) {
  //       // dispatch(
  //       //   notifications(data.senderId, data.ReceiverId, data.message, data.type)
  //       // );
  //       setNotification((prevNotification) => [data, ...prevNotification]);
  //       setMessageNotificationDot(true);
  //       setNotificationDot(true);
  //       setIncrementAll(true);
  //       // const audio = new Audio(notificationbell);
  //       // audio.play();
  //     }
  //   });

  //   socket.on("QueryNotificationR", (data) => {
  //     if (data !== null) {
  //       // dispatch(
  //       //   notifications(data.sellerId, data.buyerId, data.message, data.type)
  //       // );
  //       setNotification((prevNotification) => [data, ...prevNotification]);
  //       setNotificationDot(true);
  //       setIncrementAll(true);
  //       // const audio = new Audio(notificationbell);
  //       // audio.play();
  //     }
  //   });

  //   socket.on("notificationS", (data) => {
  //     if (data !== null) {
  //       // dispatch(
  //       //   notifications(data.sellerId, data.buyerId, data.message, data.type)
  //       // );
  //       setNotification((prevNotification) => [data, ...prevNotification]);
  //       setNotificationDot(true);
  //       setIncrementAll(true);

  //       // const audio = new Audio(notificationbell);
  //       // audio.play();
  //     }
  //   });

  //   socket.on("OrderTracking", (data) => {
  //     if (data !== null) {
  //       setNotification((prevNotification) => [data, ...prevNotification]);
  //       setNotificationDot(true);
  //       setIncrementAll(true);

  //       // const audio = new Audio(notificationbell);
  //       // audio.play();
  //     }
  //   });

  // }, []);

  const handleClickRedirect = (message) => {
    if (message.includes("account")) {
      navigate("/admindashboard/companies");
    } else if (message.includes("14")) {
      navigate("/admindashboard/marketplace");
    } else if (message.includes("membership")) {
      navigate("/admindashboard/memberdirectory");
    } else if (message.includes("onboarding")) {
      navigate("/admindashboard/companies");
    } else if (message.includes("Credit")) {
      navigate("/admindashboard");
    } else if (message.includes("credit")) {
      navigate("/admindashboard");
    } else if (message.includes("uploaded")) {
      navigate("/admindashboard/marketplace");
    } else if (message.includes("delisted")) {
      navigate("/admindashboard/marketplace");
    } else if (message.includes("15")) {
      navigate("/admindashboard/genieneactiveinactive");
    } else if (message.includes("profile")) {
      navigate("/admindashboard/companies");
    }
    handleClose();
  };

  const navigateToStandaloneSellerHub = () => {
    const listingBase =
      window.LISTING_URL ||
      process.env.REACT_APP_LISTING_URL ||
      "https://listingdevelopment-anyhv.ondigitalocean.app";
    const normalizedBase = String(listingBase).replace(/\/$/, "");
    const params = new URLSearchParams();
    params.set("source", "admin");

    try {
      const storedAdminToken =
        window.localStorage?.getItem("admintoken") || null;
      if (storedAdminToken) {
        params.set("admintoken", storedAdminToken);
      }
    } catch (e) {
      // ignore storage errors; fallback to source=admin only
      console.warn("Unable to read admintoken from localStorage", e);
    }

    window.location.href = `${normalizedBase}/sellerhub?${params.toString()}`;
  };

  useEffect(() => {
    if (getNotification !== null) {
      if (getNotification) {
        const AllCount = notificationList.filter((item) => item.read === false);
        setUnReadCountOfAll(AllCount.length);
      }
    }
  }, [getNotification, notificationList]);

  useEffect(() => {
    // if (window.location.pathname.includes("/admindashboard/marketplace/")) {
    setMarketplaceSearch("");
    // }
  }, [window.location.pathname]);

  const palette = theme.palette;

  const navbarLogo = resolvedAdminType === "bxi" ? bxiLogo : brandWorldLogo;

  return (
    <Box className="main-box">
      <AppBar
        position="static"
        elevation={0}
        sx={{
          backgroundColor: palette.background.paper,
          color: palette.text.primary,
          borderBottom: `1px solid ${palette.divider}`,
        }}
      >
        <Container maxWidth={false}>
          <Toolbar
            disableGutters
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "nowrap",
              minHeight: { xs: "64px", sm: "72px" },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {isMobile && (
                <IconButton
                  color="inherit"
                  aria-label="open menu"
                  edge="start"
                  onClick={onMenuClick}
                >
                  <MenuIcon />
                </IconButton>
              )}

              <Box sx={{ 
                width: { xs: "60px", sm: "80px", md: "110px" }, 
                display: 'flex', 
                alignItems: 'center',
                mr: { xs: 1, sm: 2 }
              }}>
                <img
                  src={navbarLogo}
                  alt="Logo"
                  style={{
                    height: "auto",
                    width: "100%",
                    maxHeight: "60px",
                    objectFit: "contain"
                  }}
                />
              </Box>
            </Box>

            {/* Search Section: list filter on marketplace/companies; global quick-jump when 2+ chars */}
            <Box
              ref={searchAnchorRef}
              sx={{
                flex: 1,
                mx: 2,
                display: { xs: "none", md: "block" },
                maxWidth: "600px",
                position: "relative",
              }}
            >
              <Search>
                <SearchIconWrapper>
                  <SearchIcon />
                </SearchIconWrapper>
                <StyledInputBase
                  placeholder="Search companies, orders, products..."
                  value={marketplacesearch}
                  onChange={(e) => setMarketplaceSearch(e.target.value)}
                />
              </Search>
              <Popper
                open={globalSearchOpen && marketplacesearch.trim().length >= 2}
                anchorEl={searchAnchorRef.current}
                placement="bottom-start"
                style={{ zIndex: 1300, width: searchAnchorRef.current?.offsetWidth || 320 }}
              >
                <Paper elevation={8} sx={{ mt: 0.5, maxHeight: 360, overflow: "auto" }}>
                  {globalSearchLoading ? (
                    <Box sx={{ p: 2, display: "flex", justifyContent: "center" }}>
                      <CircularProgress size={24} />
                    </Box>
                  ) : (
                    <>
                      {globalSearchResults.companies?.length > 0 && (
                        <>
                          <Typography variant="caption" sx={{ px: 2, pt: 1.5, fontWeight: 600, color: "text.secondary" }}>
                            Companies
                          </Typography>
                          <List dense disablePadding>
                            {globalSearchResults.companies.map((c) => (
                              <ListItemButton key={c._id} onClick={() => handleGlobalSearchSelect("company", c._id)}>
                                <ListItemText primary={c.companyName || c.email || c._id} secondary={c.email} />
                              </ListItemButton>
                            ))}
                          </List>
                        </>
                      )}
                      {globalSearchResults.orderRequests?.length > 0 && (
                        <>
                          <Typography variant="caption" sx={{ px: 2, pt: 1.5, fontWeight: 600, color: "text.secondary" }}>
                            Order requests
                          </Typography>
                          <List dense disablePadding>
                            {globalSearchResults.orderRequests.map((or) => (
                              <ListItemButton key={or._id} onClick={() => handleGlobalSearchSelect("orderRequest", or._id)}>
                                <ListItemText primary={or.orderRequestNumber || or.peerListingGroupId || or._id} secondary={or.status} />
                              </ListItemButton>
                            ))}
                          </List>
                        </>
                      )}
                      {globalSearchResults.products?.length > 0 && (
                        <>
                          <Typography variant="caption" sx={{ px: 2, pt: 1.5, fontWeight: 600, color: "text.secondary" }}>
                            Products
                          </Typography>
                          <List dense disablePadding>
                            {globalSearchResults.products.map((product) => (
                              <ListItemButton
                                key={product._id}
                                onClick={() => handleGlobalSearchSelect("product", product._id, product)}
                                sx={{ display: "flex", alignItems: "center", gap: 1.5 }}
                              >
                                <Box
                                  component="img"
                                  src={getProductSearchImage(product)}
                                  alt={product.ProductName || "product"}
                                  sx={{
                                    width: 40,
                                    height: 40,
                                    minWidth: 40,
                                    borderRadius: "8px",
                                    objectFit: "cover",
                                    border: "1px solid",
                                    borderColor: "divider",
                                  }}
                                />
                                <ListItemText
                                  primary={product.ProductName || product._id}
                                  secondary={product.ProductSubtitle || product.ProductDescription || ""}
                                  secondaryTypographyProps={{
                                    noWrap: true,
                                    sx: {
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap",
                                      maxWidth: "100%",
                                      display: "block",
                                    },
                                  }}
                                />
                              </ListItemButton>
                            ))}
                          </List>
                        </>
                      )}
                      {!globalSearchLoading && globalSearchResults.companies?.length === 0 && globalSearchResults.orderRequests?.length === 0 && globalSearchResults.products?.length === 0 && marketplacesearch.trim().length >= 2 && (
                        <Typography variant="body2" color="text.secondary" sx={{ p: 2 }}>
                          No companies, orders, or products found.
                        </Typography>
                      )}
                    </>
                  )}
                </Paper>
              </Popper>
            </Box>

            {/* Right Section */}
            <Box sx={{
              display: "flex",
              alignItems: "center",
              gap: { xs: 1, sm: 2 }
            }}>

              {canAccessSellerhub && (
                <Button
                variant="outlined"
                size="small"
                onClick={navigateToStandaloneSellerHub}
                sx={{
                  textTransform: "none",
                  fontWeight: 500,
                  borderColor: palette.divider,
                  color: palette.text.primary,
                  minWidth: "fit-content",
                  px: { xs: 1.5, sm: 2.5 },
                  py: 0.75,
                  fontSize: { xs: "11px", sm: "12px" },
                  borderRadius: "24px",
                  borderWidth: "1.5px",
                  "&:hover": {
                    borderColor: palette.text.secondary,
                    borderWidth: "1.5px",
                    backgroundColor: palette.action.hover,
                  },
                }}>
                Sellerhub
              </Button>)}

              {/* <IconButton
                sx={{ ml: 1 }}
                onClick={() => setDarkMode((prev) => !prev)}
                color="inherit"
              >
                {darkMode ? <Brightness7Icon /> : <Brightness4Icon />}
              </IconButton> */}
              <Box
                onClick={handleProfileModalopen}
                sx={{
                  display: { xs: "none", sm: "flex" },
                  alignItems: "center",
                  cursor: "pointer",
                  gap: 1.2,
                  padding: "4px 14px 4px 4px",
                  borderRadius: "30px",
                  transition: "all 0.2s ease",
                  border: `1px solid ${palette.divider}`,
                  "&:hover": {
                    backgroundColor: palette.action.hover,
                    borderColor: palette.text.secondary,
                  }
                }}
              >
                <AvatarGenerator companyname={loggedInUser?.name || "Admin User"} />
                <Typography sx={{ whiteSpace: "nowrap", fontWeight: 500, fontSize: "14px", color: palette.text.primary }}>
                  {loggedInUser?.name}
                </Typography>
              </Box>

              {canAccessNotifications && (
                <Box sx={ButtonStyle} onClick={handleOpen}>
                  {notificationDot && (
                    <Box sx={NotificationDotStyle}>
                      {incrementAll ? unReadCountOfAll + 1 : unReadCountOfAll}
                    </Box>
                  )}
                  <img
                    src={NotifyIcon}
                    alt="Notifications"
                    style={{
                      width: "auto",
                      height: isMobile ? "15px" : "17px",
                      cursor: "pointer",
                      opacity: 0.7,
                    }}
                  />
                </Box>
              )}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>
      <Modal
        open={ProfileModal}
        onClose={handleProfileModalclose}
        aria-labelledby="profile-modal"
      >
        <Box sx={style}>
          <Box
            component="img"
            src={ProfileVector}
            sx={{
              position: "absolute",
              bottom: "0%",
              right: "0%",
              width: "200px",
              height: "200px",
              zIndex: "-1",
            }}
          />
          <Typography sx={HeaderMainTextStyle}>
            {" "}
            Profile Details
            <Box
              component="img"
              src={CloseIcon}
              sx={{
                width: "25px",
                height: "auto",
                cursor: "pointer",
              }}
              onClick={handleProfileModalclose}
            />
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Typography sx={HeaderTextStyle}>
              <Box
                component="img"
                src={Username}
                sx={{
                  width: "25px",
                  height: "auto",
                }}
              />
              <Box>
                Name
                <br />
                <span style={HeaderSubTextStyle}>
                  {loggedInUser?.name}
                </span>
              </Box>
            </Typography>
            <Typography sx={HeaderTextStyle}>
              <Box
                component="img"
                src={Gmail}
                sx={{
                  width: "25px",
                  height: "auto",
                }}
              />
              <Box>
                Email
                <br />
                <span style={HeaderSubTextStyle}>
                  {loggedInUser?.email}
                </span>
              </Box>
            </Typography>
            <Typography sx={HeaderTextStyle}>
              <Box
                component="img"
                src={Role}
                sx={{
                  width: "25px",
                  height: "auto",
                }}
              />
              <Box>
                Role
                <br />
                <span style={HeaderSubTextStyle}>
                  {loggedInUser?.role}
                </span>
              </Box>
            </Typography>
            <Typography sx={HeaderTextStyle}>
              <Box
                component="img"
                src={Lastlogin}
                sx={{
                  width: "25px",
                  height: "auto",
                }}
              />
              <Box>
                Last-Login
                <br />
                <span style={HeaderSubTextStyle}>
                  {new Date(
                    loggedInUser?.lastLogin
                  )?.toLocaleString()}
                </span>
              </Box>
            </Typography>
            {loggedInUser?.acess <= 0 ? null : (
              <Typography sx={HeaderTextStyle}>
                <Box
                  component="img"
                  src={Access}
                  sx={{
                    width: "25px",
                    height: "auto",
                  }}
                />
                <Box>
                  Access
                  <br />
                  {[...new Set(loggedInUser?.acess)].map((x, i) => {
                    return (
                      <span style={HeaderSubTextStyle}>{x}, </span>
                    );
                  })}
                </Box>
              </Typography>
            )}
          </Box>
        </Box>
      </Modal>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="notifications-modal"
      >
        <Box sx={notificationModalStyle}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 1.5,
            }}
          >
            <Typography
              sx={{
                fontFamily: '"Google Sans Flex", "Inter", sans-serif',
                fontWeight: 500,
                fontSize: { xs: 17, sm: 18 },
                color: "#121317",
              }}
            >
              Notifications
            </Typography>
            <Box sx={{ display: "flex", gap: 1.5, alignItems: "center" }}>
              {resolvedAdminType === "brand_world" && (
              <Link
                to="/admindashboard/notifications"
                style={{ display: "flex", color: "inherit" }}
                onClick={handleClose}
              >
                <OpenInFullRoundedIcon
                  sx={{
                    fontSize: "18px",
                    color: "#121317",
                    cursor: "pointer",
                    borderRadius: "999px",
                    p: "2px",
                    transition: "all 180ms cubic-bezier(0.22, 1, 0.36, 1)",
                    "&:hover": {
                      backgroundColor: "rgba(183, 191, 217, 0.12)",
                    },
                    "&:active": {
                      transform: "scale(0.96)",
                    },
                  }}
                />
              </Link>
              )}
              <Box
                component="img"
                src={CloseIconForNotification}
                onClick={() => {
                  handleClose();
                }}
                sx={{ ...HeaderIcons }}
              />
            </Box>
          </Box>

          <Box
            sx={{
              maxHeight: { xs: "300px", sm: "260px" },
              overflowY: "auto",
              pr: 0.5,
              display: "flex",
              flexDirection: "column",
              gap: 1,
            }}
          >
            {modalNotificationList?.length ? (
              modalNotificationList.map((item, idx) => (
                <Box
                  key={`${item?._id || "n"}-${idx}`}
                  sx={{
                    borderRadius: "16px",
                    background: "rgba(183, 191, 217, 0.1)",
                    border: "1px solid rgba(33, 34, 38, 0.06)",
                    px: 1.5,
                    py: 1.25,
                    transition: "all 220ms cubic-bezier(0.22, 1, 0.36, 1)",
                    "&:hover": {
                      borderColor: "rgba(18, 19, 23, 0.14)",
                      boxShadow: "0 8px 20px rgba(18, 19, 23, 0.08)",
                      transform: "translateY(-1px)",
                    },
                  }}
                >
                  <Box sx={{ display: "flex", gap: 1.25, alignItems: "flex-start" }}>
                    <Box
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        background: item?.read ? "transparent" : "#2563eb",
                        mt: 0.8,
                        flexShrink: 0,
                      }}
                    />
                    <AvatarGenerator companyname={companyName} />
                    <Box sx={{ flex: 1, minWidth: 0 }}>
                      {getSafeTitle(item) ? (
                        <Typography
                          sx={{
                            fontFamily: '"Google Sans Flex", "Inter", sans-serif',
                            fontWeight: 500,
                            fontSize: "13px",
                            lineHeight: 1.4,
                            color: "#121317",
                          }}
                        >
                          {getSafeTitle(item)}
                        </Typography>
                      ) : null}
                      <Typography
                        sx={{
                          fontFamily: '"Google Sans Flex", "Inter", sans-serif',
                          fontSize: "12.5px",
                          lineHeight: 1.45,
                          color: "#475569",
                          cursor: "pointer",
                          transition: "color 180ms cubic-bezier(0.22, 1, 0.36, 1)",
                          "&:hover": {
                            color: "#0f172a",
                          },
                        }}
                        onClick={() => {
                          handleClickRedirect(getSafeMessage(item));
                        }}
                      >
                        {getSafeBody(item)}
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          mt: 0.75,
                        }}
                      >
                        <Typography
                          sx={{
                            fontFamily: '"Google Sans Flex", "Inter", sans-serif',
                            fontSize: "10px",
                            color: "#64748b",
                          }}
                        >
                          {format(item?.createdAt)}
                        </Typography>
                        <Typography
                          sx={{
                            fontFamily: '"Google Sans Flex", "Inter", sans-serif',
                            fontSize: "10px",
                            color: "#2563eb",
                            cursor: "pointer",
                            borderRadius: "999px",
                            px: 0.8,
                            py: 0.25,
                            transition: "all 160ms cubic-bezier(0.22, 1, 0.36, 1)",
                            "&:hover": {
                              backgroundColor: "rgba(183, 191, 217, 0.1)",
                            },
                            "&:active": {
                              transform: "translateY(1px)",
                            },
                          }}
                          onClick={() => {
                            UpdateNotifications(item);
                            setUpdateNotiticationStatus(!UpdateNotiticationStatus);
                          }}
                        >
                          {item?.read ? "Mark unread" : "Mark read"}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              ))
            ) : (
              <Box
                sx={{
                  borderRadius: "16px",
                  border: "1px solid rgba(33, 34, 38, 0.06)",
                  py: 4,
                  textAlign: "center",
                  color: "#64748b",
                  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
                  fontSize: "13px",
                }}
              >
                No notifications available
              </Box>
            )}
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};
export default AdminHeader;
const ButtonStyle = {
  width: { xs: "36px", sm: "40px" },
  height: { xs: "36px", sm: "40px" },
  background: "transparent",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "1px solid #e8eaed",
  borderRadius: "12px",
  cursor: "pointer",
  position: "relative",
  transition: "border-color 0.15s ease",
  "&:hover": {
    borderColor: "#dadce0",
  },
};

const NotificationDotStyle = {
  bgcolor: "#000000",
  minHeight: "14px",
  height: "auto",
  minWidth: "14px",
  width: "auto",
  borderRadius: "8px",
  position: "absolute",
  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
  fontWeight: 600,
  fontSize: { xs: "8px", sm: "9px" },
  px: 0.4,
  top: { xs: "-2px", sm: "-2px" },
  right: { xs: "-2px", sm: "-2px" },
  zIndex: 1,
  color: "white",
};

// const style = {
//   position: 'absolute',
//   top: '37%',
//   left: '80%',
//   transform: 'translate(-50%, -50%)',
//   width: '28%',
//   height: '370px',
//   overflow: 'scroll',
//   bgcolor: 'background.paper',
//   border: '0px solid #000',
//   boxShadow: 4,
//   p: '30px',
//   borderRadiusTopRight: '10px',
//   maxWidth: '500px',
//   minWidth: '250px',
//   borderRadius: '20px 20px 0px 0px',
// };

const ExploreButtonStyle = {
  width: "92px",
  height: "44px",
  background: "#FFFFFF",
  borderRadius: "6px",
  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "21px",
  textAlign: "center",
  color: "#64748b",
  textTransform: "none",
};

const ButtonsStyle = {
  width: "45px",
  height: "45px",
  background: "#FFFFFF",
  display: "flex",
  justifyContent: "center",
  alignContent: "center",
  alignItems: "center",
  boxShadow: "0px 2px 5px rgba(38, 51, 77, 0.03)",
  borderRadius: "100px",
  cursor: "pointer",
};

const UnActiveExploreButtonStyle = {
  width: "92px",
  height: "44px",
  background: "transparent",
  borderRadius: "6px",
  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
  fontStyle: "normal",
  fontWeight: 600,
  fontSize: "12px",
  lineHeight: "21px",
  textAlign: "center",
  color: "#94a3b8",
  textTransform: "none",
};

const HeaderMainTextStyle = {
  display: "flex",
  justifyContent: "space-between",
  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
  textAlign: "left",
  color: "#64748b",
  fontSize: "16px",
  fontWeight: 500,
  borderBottom: "0.5px solid #e2e8f0",
  p: 1,
};
const HeaderTextStyle = {
  display: "flex",
  gap: "20px",
  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
  fontSize: "15.5px",
  fontWeight: 600,
  color: "#64748b",
  p: 1,
};
const HeaderSubTextStyle = {
  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
  fontSize: "14px",
  fontWeight: 500,
  textAlign: "left",
  color: "#94a3b8",
  p: 1,
};

const UserNameTextStyle = {
  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
  fontStyle: "normal",
  fontWeight: 700,
  fontSize: "14px",
  lineHeight: "20px",
  textAlign: "center",
  color: "#64748b",
};


const HeaderIcons = {
  width: "20px",
  height: "20px",
  cursor: "pointer",
};

const barter = {
  fontFamily: '"Google Sans Flex", "Inter", sans-serif',
  fontWeight: 700,
  color: "#64748b",
  textDecoration: "none",
  fontSize: "16px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
